<div class="container" mat-dialog-title>
  <div class="header-title display-flex align-items-center justify-content-space-between">
    <div class="w-100 display-flex grid-gap-8">
      <input
        class="input input-title"
        aria-label="label-input"
        [formControl]="title"
        [maxLength]="70"
        [placeholder]="'Title'" />
    </div>
    <button
      type="button"
      class="display-flex align-items-center justify-content-center"
      (click)="cancel()"
      mat-icon-button>
      <app-icon [svg]="EIcon.CLOSE" [iconWidth]="20" [iconHeight]="20" [iconColor]="EColorPalette.cGray"></app-icon>
    </button>
  </div>
</div>

<mat-dialog-content *ngIf="form">
  <form [formGroup]="form" class="display-flex flex-column grid-gap-12">
    <ng-container *ngIf="data.useDynamicValue && data.placeholders?.length > 0; else custom">
      <div class="display-flex flex-column grid-gap-8">
        <div class="display-flex">
          <app-input
            class="w-100"
            [matFormCss]="'border-radius-partial-left'"
            formControlName="search"
            (keydownEnterEvent)="onSearch()"
            [attrPlaceholder]="'Search...'"></app-input>

          <div class="search-container display-flex align-items-center justify-content-center">
            <app-icon
              [iconColor]="EColorPalette.cGray7"
              [iconHeight]="18"
              [iconWidth]="18"
              [svg]="EIcon.ICON_SEARCH"></app-icon>
          </div>
        </div>
        <div class="placeholders-container">
          <app-radio-button
            formControlName="defaultValue"
            [items]="placeholders"
            [radioGroupClass]="'display-flex flex-column'"
            [optionCss]="'body'"></app-radio-button>
        </div>
      </div>
    </ng-container>

    <ng-template #custom>
      <ng-container [ngSwitch]="data?.question?.type">
        <!-- Dropdown -->
        <div *ngSwitchCase="'dropdown'" class="display-flex justify-content-center">
          <app-radio-button-dropdown
            class="w-100"
            formControlName="defaultValue"
            [items]="dropDownOptions"
            [allowClear]="true"
            [allowSearch]="false"
            [autoSortList]="false"
            [attrPlaceholder]="'Select option'"
            attrAppendTo="body"></app-radio-button-dropdown>
        </div>

        <!-- Date (only) -->
        <div *ngSwitchCase="'date'" class="display-flex justify-content-center">
          <div class="modal-calendar">
            <mat-calendar
              #customDateCalendar
              [headerComponent]="calendarHeader"
              [selected]="tempDate?.toDate()"
              (selectedChange)="onDateSelected($event)"></mat-calendar>
            <span
              class="display-flex align-items-center justify-content-center clear"
              [ngClass]="{ 'clear-disabled': !tempDate }"
              (click)="onClearDate()">
              Clear
            </span>
          </div>
        </div>

        <!-- Date & Time -->
        <div
          *ngSwitchCase="'dateTime'"
          class="display-flex flex-column align-items-center justify-content-center grid-gap-8">
          <div class="modal-calendar">
            <mat-calendar
              #customDateCalendar
              [headerComponent]="calendarHeader"
              [selected]="tempDate?.toDate()"
              (selectedChange)="onDateSelected($event)"></mat-calendar>
            <span
              class="display-flex align-items-center justify-content-center clear"
              [ngClass]="{ 'clear-disabled': !tempDate }"
              (click)="onClearDate()">
              Clear
            </span>
          </div>
          <app-radio-button-dropdown
            [attrDisable]="!tempDate"
            class="flex-1"
            formControlName="dateTimeValueTime"
            [allowClear]="true"
            [allowSearch]="false"
            [autoSortList]="false"
            [items]="dateTimeOptions"
            [attrPlaceholder]="'Select time'"
            attrAppendTo="body"></app-radio-button-dropdown>
        </div>

        <!-- Text -->
        <div *ngSwitchCase="'text'" class="w-100 display-flex align-items-center grid-gap-8">
          <app-input-area
            class="w-100"
            [inputCss]="'hp-92'"
            formControlName="defaultValue"
            [attrPlaceholder]="'Enter text'"></app-input-area>
        </div>

        <!-- Number -->
        <div *ngSwitchCase="'number'" class="w-100 display-flex align-items-center grid-gap-8">
          <app-input
            class="w-100"
            formControlName="defaultValue"
            [attrPlaceholder]="'Enter number'"
            [attrMask]="'separator.2'"></app-input>
        </div>

        <!-- Int -->
        <div *ngSwitchCase="'int'" class="w-100 display-flex align-items-center grid-gap-8">
          <app-input
            class="w-100"
            formControlName="defaultValue"
            [attrPlaceholder]="'Enter integer'"
            [attrMask]="'separator.0'"></app-input>
        </div>

        <!-- Money -->
        <div *ngSwitchCase="'money'" class="w-100 display-flex align-items-center grid-gap-8">
          <app-input
            class="w-100"
            formControlName="defaultValue"
            [attrPlaceholder]="'Enter amount'"
            [useCurrencyFormatter]="true"></app-input>
        </div>

        <!-- Default (fallback) -->
        <div *ngSwitchDefault class="w-100 display-flex align-items-center grid-gap-8">
          <app-input class="w-100" formControlName="defaultValue" [attrPlaceholder]="'Enter text'"></app-input>
        </div>
      </ng-container>
    </ng-template>
  </form>
</mat-dialog-content>

<div class="display-flex align-items-center justify-content-end grid-gap-10 actions">
  <button class="display-flex align-items-center justify-content-center" (click)="cancel()" mat-button color="primary">
    Cancel
  </button>
  <button class="display-flex align-items-center justify-content-center" (click)="save()" mat-button color="primary">
    Save
  </button>
</div>
